"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFromToProps = void 0;
var date_fns_1 = require("date-fns");
/**
 * Build the `fromDate` and `toDate` values, given the fromMonth/toMonth
 * or fromYear/toYear props.
 */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = date_fns_1.startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = date_fns_1.startOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? date_fns_1.startOfDay(fromDate) : undefined,
        toDate: toDate ? date_fns_1.startOfDay(toDate) : undefined
    };
}
exports.parseFromToProps = parseFromToProps;
//# sourceMappingURL=parseFromToProps.js.map